import { render } from "./columnSetting.vue?vue&type=template&id=08871f03&scoped=true"
import script from "./columnSetting.vue?vue&type=script&lang=js"
export * from "./columnSetting.vue?vue&type=script&lang=js"

import "./columnSetting.vue?vue&type=style&index=0&id=08871f03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08871f03"]])

export default __exports__